export const manualModel = {
  mn: null,
  cm: null,
  nm: null,
  dm: null,
  st: false,
  gc: true,
};
